import { appInitApi } from '@/api/index';

const state = {
    homeSubTabList: [], // home二级导航列表
    matchSubTabList: [], // match二级导航列表
    statsSubTabList: [], // stats二级导航列表
    videoSubTabList: [], // video二级导航列表
    subtitChoose: '', // 二级导航当前选中tab
    thirdTitChoose: '' // 三级导航当前选中tab
};

const getters = {
    getHomeSubTabList: state => state.homeSubTabList,
    getMatchSubTabList: state => state.matchSubTabList,
    getStatsSubTabList: state => state.statsSubTabList,
    getVideoSubTabList: state => state.videoSubTabList,
    getSubtitChoose: state => state.subtitChoose,
    getThirdTitChoose: state => state.thirdTitChoose
};

const actions = {
    menusListApi ({ commit, state, rootState }, { subtitle, type }) {
        // - 转成 空格
        state.subtitChoose = subtitle && subtitle.replace(/-/g, ' ');
        if (type === 'NEWS') { // 如果是home新闻列表页面
            return appInitApi.menusApi().then(response => {
                commit('setHomeMenuList', response);
            }, error => {
                console.log(error);
            });
        } else if (type === 'MATCH') { // 如果是match比赛列表页面
            return appInitApi.matchMenusApi().then(response => {
                commit('setMatchMenuList', response);
            }, error => {
                console.log(error);
            });
        } else if (type === 'STATS') { // 如果是stats列表页面
            return appInitApi.statsMenusApi().then(response => {
                commit('setStatsMenuList', response);
            }, error => {
                console.log(error);
            });
        } else if (type === 'VIDEO') { // 如果是stats列表页面
            return appInitApi.videoMenusApi().then(response => {
                commit('setVideoMenuList', response);
            }, error => {
                console.log(error);
            });
        }
    }
};

const mutations = {
    setHomeMenuList (state, params) { // home页二级导航
        state.homeSubTabList = [];
        params.menus.news.forEach(e => {
            let dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.homeSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.homeSubTabList[0]) {
            state.subtitChoose = state.homeSubTabList[0].label;
        }
    },
    setMatchMenuList (state, params) { // match列表页二级导航
        state.matchSubTabList = [];
        params.menus.match_tab.forEach(e => {
            let dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.matchSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.matchSubTabList[0]) {
            state.subtitChoose = state.matchSubTabList[0].label;
        }
    },
    setStatsMenuList (state, params) { // stats列表页二级导航
        state.statsSubTabList = [];
        params.menus.ranking.forEach(e => {
            let dataSubtit = { 'label': e.label, 'urlApi': e.sub_tabs };
            state.statsSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.statsSubTabList[0]) {
            state.subtitChoose = state.statsSubTabList[0].label;
        }
        if (!state.thirdTitChoose && state.thirdTitChoose[0]) {
            state.thirdTitChoose = state.statsSubTabList[0].sub_tabs[0].title;
        }
    },
    setVideoMenuList (state, params) { // match列表页二级导航
        state.videoSubTabList = [];
        params.menus.video.forEach(e => {
            let dataSubtit = { 'label': e.label, 'urlApi': e.api };
            state.videoSubTabList.push(dataSubtit);
        });
        if (!state.subtitChoose && state.videoSubTabList[0]) {
            state.subtitChoose = state.videoSubTabList[0].label;
        }
    },
    setSubtitChoose (state, params) { // 当前选中的tab
        state.subtitChoose = params;
    },
    setThirdTitChoose (state, params) { // 当前三级导航选中的tab
        state.thirdTitChoose = params;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/navStore.js